import React, { useEffect, useState } from 'react';
import api from '../api';

export default function Credits() {
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState(0);

  const fetchData = () => {
    api.get('/credits/balance').then(r => setBalance(r.data.credits));
    api.get('/credits/transactions').then(r => setTransactions(r.data));
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <div className="cards" style={{gridTemplateColumns:'repeat(2,1fr)'}}>
        <div className="card green">
          <div className="label">Current Balance</div>
          <div className="value">₹{parseFloat(balance).toFixed(2)}</div>
        </div>
        <div className="card blue">
          <div className="label">Total Transactions</div>
          <div className="value">{transactions.length}</div>
        </div>
      </div>

      <div className="box">
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
          <h3 style={{marginBottom:0}}>Transaction History</h3>
          <span style={{fontSize:'12px',color:'#aaa'}}>Auto refreshes every 30s</span>
        </div>
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Type</th>
              <th>Amount</th>
              <th>Note</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {transactions.length === 0 && (
              <tr><td colSpan="5" style={{textAlign:'center',color:'#aaa',padding:'32px'}}>No transactions yet</td></tr>
            )}
            {transactions.map((t, i) => (
              <tr key={t.id}>
                <td>{i+1}</td>
                <td>
                  <span className={`badge ${t.type === 'credit' ? 'delivered' : 'failed'}`}>
                    {t.type === 'credit' ? '+ Credit' : '- Debit'}
                  </span>
                </td>
                <td style={{fontWeight:600, color: t.type==='credit'?'#34a853':'#ea4335'}}>
                  {t.type==='credit'?'+':'-'}₹{parseFloat(t.amount).toFixed(2)}
                </td>
                <td>{t.note}</td>
                <td>{new Date(t.created_at).toLocaleString('en-IN')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
